import { isAzure } from "utils/environmentUtils";

/**
 * Submit a conch job to the conch batch service
 *
 * @param ggEnvironment Environment string returned from the custom hook
 * @param jobname Job Name to be submitted
 * @param jobdef Job Definition
 * @param jobqueue Job Queue
 * @param params Full params JSON
 * @param params_zipped The params JSON but gzipped and b64 encoded
 * @returns
 */
export default async function submitConchBatch<T extends conch.ReportParams>(
  ggEnvironment: SensoryLinkEnvironment,
  jobname: string,
  jobdef: conch.JobDefinition,
  jobqueue: string,
  params: T,
  params_zipped?: string
): Promise<Response> {

  const IS_AZURE = isAzure(ggEnvironment);

  if (IS_AZURE) {

    let pool_namespace: string;
    switch (ggEnvironment) {
      case "production_azure":
        pool_namespace = "aipdmedium-prod";
        break;
      case "development_azure":
        pool_namespace = "aipdmedium-nonprod";
        break;
      case "pre4azure":
      default:
        pool_namespace = "aipdmedium-preprod";
    }

    return fetch('/conchBatch/uploadSubmitJobAzure', {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        pool_namespace: pool_namespace,
        params: params,
        params_zipped: params_zipped,
      }),
    });
  }

  return fetch('/conchBatch/uploadSubmitJobAWS', {
    method: 'POST',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      jobname,
      jobdef,
      jobqueue,
      params: params,
      params_zipped: params_zipped,
    }),
  });
}
